import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction27, obtenerDatosAntecedentes, obtenerDatosGrilla } from '../../store/actions/antecedentes-jud-acion'
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import Antecedentes from './Antecedentes'
import Grilla from './grilla'
import {LoadingComponent} from 'recupero-comunes'


const AntecedentesJudicialesModal = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso , tipoGestion, ambitoGestion}) => {
    const [loading,setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
   const dispatch=useDispatch()
    
    useEffect(() => {     

         dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
        if(llaves){  
            setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 27
        })).toString('base64')
        dispatch(configuracionFormAction27(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idImplicado": llaves && llaves['idImplicado'],
                "idCaso": llaves && llaves['idCaso']
            })).toString('base64')
            dispatch(obtenerDatosAntecedentes(query))
        })
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idImplicado": llaves && llaves['idImplicado'],
                "idCaso": llaves && llaves['idCaso'],
                "idModoIngreso1":238006, 
                "idModoIngreso2":null, 
                "tipoGestion":tipoGestion,//207001
                "ambitoGestion":ambitoGestion//232002
            })).toString('base64')
            dispatch(obtenerDatosGrilla(query))
        })
        .then(()=>{
            setLoading(false)
        })
    
    }
    }, [dispatch,llaves])
    return (
        <>
        <LoadingComponent show={loading}/>
            <Antecedentes 
                handleClose={handleClose}
                />
                <Grilla/>
        </>
    )
}

export default AntecedentesJudicialesModal
